/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Thumbnail_Event_Groups_LabelInputs */

const en_explorer_thumbnail_event_groups_label = /** @type {(inputs: Explorer_Thumbnail_Event_Groups_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event Groups:`)
};

const fr_explorer_thumbnail_event_groups_label = /** @type {(inputs: Explorer_Thumbnail_Event_Groups_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groupes d'evenements :`)
};

const de_explorer_thumbnail_event_groups_label = /** @type {(inputs: Explorer_Thumbnail_Event_Groups_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veranstaltungsgruppen:`)
};

const it_explorer_thumbnail_event_groups_label = /** @type {(inputs: Explorer_Thumbnail_Event_Groups_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppi di eventi:`)
};

const ru_explorer_thumbnail_event_groups_label = /** @type {(inputs: Explorer_Thumbnail_Event_Groups_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Группы мероприятий:`)
};

const es_explorer_thumbnail_event_groups_label = /** @type {(inputs: Explorer_Thumbnail_Event_Groups_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupos de eventos:`)
};

const zh_cn2_explorer_thumbnail_event_groups_label = /** @type {(inputs: Explorer_Thumbnail_Event_Groups_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`活动组：`)
};

const ja_explorer_thumbnail_event_groups_label = /** @type {(inputs: Explorer_Thumbnail_Event_Groups_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントグループ:`)
};

const hi_explorer_thumbnail_event_groups_label = /** @type {(inputs: Explorer_Thumbnail_Event_Groups_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट समूह:`)
};

const pt_pt2_explorer_thumbnail_event_groups_label = /** @type {(inputs: Explorer_Thumbnail_Event_Groups_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupos de eventos:`)
};

/**
* | output |
* | --- |
* | "Event Groups:" |
*
* @param {Explorer_Thumbnail_Event_Groups_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_thumbnail_event_groups_label = /** @type {((inputs?: Explorer_Thumbnail_Event_Groups_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Thumbnail_Event_Groups_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_thumbnail_event_groups_label(inputs)
	if (locale === "de") return de_explorer_thumbnail_event_groups_label(inputs)
	if (locale === "it") return it_explorer_thumbnail_event_groups_label(inputs)
	if (locale === "ru") return ru_explorer_thumbnail_event_groups_label(inputs)
	if (locale === "es") return es_explorer_thumbnail_event_groups_label(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_thumbnail_event_groups_label(inputs)
	if (locale === "ja") return ja_explorer_thumbnail_event_groups_label(inputs)
	if (locale === "hi") return hi_explorer_thumbnail_event_groups_label(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_thumbnail_event_groups_label(inputs)
	return en_explorer_thumbnail_event_groups_label(inputs)
});